// eslint-disable-next-line angular/no-service-method
angular.
module("digiexam.archive").
service("ArchiveRepository", function archiveRepositoryService(ExamRepository, Exam, $http) {
	"use strict";

	// eslint-disable-next-line consistent-this
	var repo = this;
	repo.groups = [];
	repo.courses = [];

	repo.refreshArchive = function refreshArchive() {
		return $http.get("/archive/list/").then(function success(response) {
			if (response.data.exams) {
				for (var i = 0; i < response.data.exams.length; i++) {
					ExamRepository.cache(new Exam(response.data.exams[i]));
				}
			}

			if (response.data.groups) {
				repo.groups = response.data.groups;
			}

			if (response.data.courses) {
				repo.courses = response.data.courses;
			}
		});
	};
});
